"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4561],{

/***/ 55566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ TextareaField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/@next/utils/styles.ts
var styles = __webpack_require__(71454);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/components/atoms/InputLabel/index.ts + 2 modules
var InputLabel = __webpack_require__(89524);
;// CONCATENATED MODULE: ./src/@next/components/atoms/Textarea/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border: 1px solid #cfd7da;\n  color: ",
        ";\n  background-color: ",
        ";\n  outline: none;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n  &:hover {\n  }\n  label {\n    top: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  top: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  & > span {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0.9rem 1rem;\n  margin: 0;\n  border: none;\n  width: 100%;\n  font-size: ",
        ";\n  line-height: 1.6em;\n  outline: none;\n  background-color: transparent;\n  color: ",
        ";\n  font-family: ",
        ";\n  height: 190px;\n  &::placeholder {\n    color: rgba(44, 44, 44, 0.3);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var getEdgeColor = function(param) {
    var active = param.active, error = param.error, disabled = param.disabled, theme = param.theme, hovered = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (disabled) {
        return theme.colors.disabled;
    }
    if (error) {
        return theme.colors.error;
    }
    if (hovered) {
        return theme.colors.secondary;
    }
    return active ? theme.colors.secondary : theme.colors.grayDark;
};
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return getEdgeColor(props);
}, function(props) {
    return props.whiteBg ? "#ffffff" : "transparent";
}, function(props) {
    return props.active ? "0" : "30px";
});
var StyledInputLabel = (0,globalStyles/* styled */.zo)(InputLabel/* InputLabel */.A)(_templateObject1(), function(props) {
    return props.active ? "0!important" : "30px";
});
var Content = globalStyles/* styled.span */.zo.span(_templateObject2());
var InputWrapper = globalStyles/* styled.div */.zo.div(_templateObject3());
var Input = globalStyles/* styled.textarea */.zo.textarea(_templateObject4(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, function(props) {
    return props.theme.typography.extraFontFamily;
});

;// CONCATENATED MODULE: ./src/@next/components/atoms/Textarea/Textarea.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 







var Textarea = function(_param) {
    var onBlur = _param.onBlur, onFocus = _param.onFocus, _contentLeft = _param.contentLeft, contentLeft = _contentLeft === void 0 ? null : _contentLeft, _contentRight = _param.contentRight, contentRight = _contentRight === void 0 ? null : _contentRight, _error = _param.error, error = _error === void 0 ? false : _error, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, placeholder = _param.placeholder, label = _param.label, value = _param.value, onChange = _param.onChange, _maxLength = _param.maxLength, maxLength = _maxLength === void 0 ? 50 : _maxLength, type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onBlur",
        "onFocus",
        "contentLeft",
        "contentRight",
        "error",
        "disabled",
        "placeholder",
        "label",
        "value",
        "onChange",
        "maxLength",
        "type"
    ]);
    var elementRef = react.useRef(null);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), active = ref[0], setActive = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState("transparent"), 2), labelBackground = ref1[0], setColor = ref1[1];
    react.useEffect(function() {
        if (elementRef) {
            var color = (0,styles/* getBackgroundColor */.d)(elementRef.current);
            setColor(color);
        }
    }, []);
    var handleFocus = react.useCallback(function(e) {
        setActive(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [
        setActive,
        onFocus
    ]);
    var handleBlur = react.useCallback(function(e) {
        setActive(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [
        setActive,
        onBlur
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        active: active,
        error: error,
        disabled: disabled,
        ref: elementRef,
        whiteBg: true,
        children: [
            contentLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: contentLeft
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        value: value,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        disabled: disabled,
                        onChange: onChange,
                        maxLength: maxLength,
                        placeholder: placeholder && !label ? placeholder : ""
                    })),
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputLabel, {
                        labelBackground: labelBackground,
                        active: active || !!value,
                        className: "review-popup__styled-input-label",
                        children: label
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/atoms/Textarea/index.ts


;// CONCATENATED MODULE: ./src/@next/components/molecules/TextareaField/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10px;\n  position: relative;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var TextField = globalStyles/* styled.div */.zo.div(styles_templateObject());
TextField.displayName = "S.TextField";
var HelpText = globalStyles/* styled.span */.zo.span(styles_templateObject1(), function(props) {
    return props.theme.input.labelColor;
}, function(props) {
    return props.theme.input.labelFontSize;
});
var ErrorMessages = globalStyles/* styled.div */.zo.div(styles_templateObject2());

;// CONCATENATED MODULE: ./src/@next/components/molecules/TextareaField/TextareaField.tsx








var TextareaField = function(_param) {
    var errors = _param.errors, helpText = _param.helpText, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "errors",
        "helpText"
    ]);
    var hasErrors = !!(errors && errors.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextField, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                error: hasErrors
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorMessages, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: errors
                    }),
                    helpText && /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpText, {
                        children: helpText
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/TextareaField/index.ts



/***/ }),

/***/ 64561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ ContactsForm_ContactsForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@next/components/molecules/TextareaField/index.ts + 5 modules
var TextareaField = __webpack_require__(55566);
// EXTERNAL MODULE: ./src/@next/components/molecules/TextField/index.ts + 2 modules
var TextField = __webpack_require__(80648);
// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@next/components/atoms/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(73881);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsForm/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  ",
        "\n  & > div {\n    width: calc(50% - 10px / 2);\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  width: 100%;\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin: 20px auto 0;\n    width: 160px;\n    height: 48px;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 36px auto 0;\n  width: 300px;\n  height: 64px;\n  display: block;\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: -5px 0 5px;\n  font-size: ",
        ";\n  color: #cfd7da;\n  text-align: right;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n    margin-bottom: 0.7rem;\n    input:checked + div {\n      span {\n        position: relative;\n        &:after {\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n        }\n      }\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  a {\n    margin-left: 5px;\n    text-decoration: underline;\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var ContactsForm = globalStyles/* styled.form */.zo.form(_templateObject());
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject1());
var RowWithTwoCells = globalStyles/* styled.div */.zo.div(_templateObject4(), function(props) {
    return props.margin && "margin-bottom: 0px;";
}, globalStyles/* media.xSmallScreen */.BC.xSmallScreen(_templateObject2()), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject3(), function(props) {
    return props.margin && "margin-bottom: 0px;";
}));
var RowWithOneCell = globalStyles/* styled.div */.zo.div(_templateObject6(), function(props) {
    return props.margin && "margin-bottom: 0px;";
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject5(), function(props) {
    return props.margin && "margin-bottom: 0px;";
}));
var StyledButton = (0,globalStyles/* styled */.zo)(Button/* Button */.z)(_templateObject8(), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject7()));
var CharactersCounter = globalStyles/* styled.div */.zo.div(_templateObject9(), function(props) {
    return props.theme.typography.labelFontSize;
});
var StyledCheckbox = (0,globalStyles/* styled */.zo)(Checkbox/* Checkbox */.X)(_templateObject11(), constants/* baseFontColor */.Bq, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject10()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsForm/ContactsForm.tsx











var ContactsForm_ContactsForm = function(_param) {
    var submit = _param.handleSubmit, defaultValues = _param.defaultValues, props = (0,_object_without_properties/* default */.Z)(_param, [
        "handleSubmit",
        "defaultValues"
    ]);
    var ref;
    var ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: defaultValues
    }), control = ref1.control, watch = ref1.watch, errors = ref1.formState.errors, handleSubmit = ref1.handleSubmit;
    var watchFields = watch();
    var intl = (0,useIntl/* default */.Z)();
    var ref2 = (0,react.useState)(false), accepted = ref2[0], setAccepted = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactsForm, {
        className: "contact-form",
        onSubmit: handleSubmit(submit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowWithOneCell, {
                        margin: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "subject",
                            control: control,
                            rules: {
                                required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                            },
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                                    whiteBg: true,
                                    label: intl.formatMessage(src_intl/* commonMessages.subject */.i4.subject),
                                    autoComplete: "given-name",
                                    maxLength: 100,
                                    errors: errors.subject ? [
                                        {
                                            message: errors.subject.message
                                        }
                                    ] : undefined
                                }, field));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CharactersCounter, {
                        children: [
                            100 - (((ref = watchFields.subject) === null || ref === void 0 ? void 0 : ref.length) || 0),
                            " ",
                            intl.formatMessage(src_intl/* commonMessages.charactersLeft */.i4.charactersLeft)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowWithOneCell, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "customerEmail",
                            control: control,
                            rules: {
                                pattern: {
                                    message: intl.formatMessage(src_intl/* validationCommonMsg.invalidEmail */.a4.invalidEmail),
                                    value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
                                },
                                required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                            },
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* TextField */.n, (0,_object_spread/* default */.Z)({
                                    whiteBg: true,
                                    label: intl.formatMessage(src_intl/* commonMessages.yourEmailAddress */.i4.yourEmailAddress),
                                    autoComplete: "email",
                                    errors: errors.customerEmail ? [
                                        {
                                            message: errors.customerEmail.message
                                        }
                                    ] : undefined
                                }, field));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowWithOneCell, {
                        margin: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                            name: "message",
                            control: control,
                            rules: {
                                required: intl.formatMessage(src_intl/* validationCommonMsg.required */.a4.required)
                            },
                            render: function(param) {
                                var field = param.field;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextareaField/* TextareaField */.X, (0,_object_spread/* default */.Z)({
                                    whiteBg: true,
                                    label: intl.formatMessage(src_intl/* commonMessages.yourMessage */.i4.yourMessage),
                                    maxLength: 1200,
                                    errors: errors.message ? [
                                        {
                                            message: errors.message.message
                                        }
                                    ] : undefined
                                }, field));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CharactersCounter, {
                        children: [
                            1200 - watchFields.message.length,
                            " ",
                            intl.formatMessage(src_intl/* commonMessages.charactersLeft */.i4.charactersLeft)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowWithOneCell, {
                        margin: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCheckbox, {
                            name: "accepted",
                            checked: accepted,
                            onChange: function() {
                                return setAccepted(function(v) {
                                    return !v;
                                });
                            },
                            color: "primary",
                            children: [
                                intl.formatMessage(src_intl/* commonMessages.accept */.i4.accept),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: intl.formatMessage(src_intl/* commonMessages.termsOfService */.i4.termsOfService)
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowWithOneCell, {
                        margin: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            type: "submit",
                            disabled: !accepted,
                            children: intl.formatMessage(src_intl/* commonMessages.send */.i4.send)
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/ContactsForm/index.ts



/***/ })

}]);